// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-2c520128]{min-height:100vh;width:100%;position:relative;display:flex;flex-flow:column nowrap;padding:0 0 24px}.base-content[data-v-2c520128]{position:relative;flex-grow:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
